import _ from 'lodash';
import defaultTheme from './default-theme.js';

export const createCustomTheme = (theme) => {
    const newTheme = _.merge(defaultTheme, theme);
    return newTheme;
};

export { createColor } from './lib/color';
